import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import {
  IParceiro,
  ParceiroEventoSaldoCredito,
  ParceiroEventoSaldoCreditoResult
} from '../model';

@Injectable()
export class ParceiroService<
  T extends IParceiro = IParceiro
> extends EntityService<T> {
  constructor(protected configService: ConfigService) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'parceiro'
      }
    );
  }

  /**
   * Responsável por enviar um evento de atualização do limite de credito
   * @param cliente_id
   * @param evento
   * @returns
   */
  atualizarSaldoDeCredito(
    parceiro_id: string,
    evento: ParceiroEventoSaldoCredito
  ) {
    const url = `${this.baseURL}/${parceiro_id}/reg_parceiro_saldo_credito_evento`;
    return this.http.put<{ evento: ParceiroEventoSaldoCreditoResult }>(
      url,
      evento,
      {
        headers: this.getHeader()
      }
    );
  }
}
